import colors from './colors';

export default {
  common: {
    white: colors.white,
    cream: colors.cream,
    grey: colors.grey,
  },
  primary: {
    main: colors.blue500,
    mainDisabled: colors.blueDisabled,
    mainOpaque: colors.blueOpaque,
  },
  secondary: {
    main: colors.cactus500,
    lightMain: colors.blue50,
  },
  error: {
    main: colors.pink500,
    light: colors.pink50,
    contrastMain: colors.pink800,
  },
  success: {
    main: colors.cactus500,
    light: colors.cactus50,
    contrastMain: colors.cactus800,
  },
  info: {
    main: colors.blue500,
    light: colors.blue50,
    divider: colors.black,
  },
  background: {
    default: colors.white,
    textInput: colors.neutral50,
    divider: colors.blue300,
    lightDivider: colors.blueLight,
    separator: colors.copper,
    header: colors.blue500,
    contrastShadow: colors.whiteShadow,
    neutral: colors.neutral50,
    tag: colors.neutral50,
    tagBorder: colors.neutral300,
    calories: colors.blue50,
    total: colors.blue50,
    progress: colors.pink50,
    heart: colors.pink300,
    splitItems: colors.blue600,
    billTotalContainer: colors.blue50,
    textInputTitle: colors.blue200,
    shadow: colors.shadow,
    discounted: colors.redCopper,
    lightButton: colors.neutral100,
    container: colors.skyGrey,
  },
  action: {
    disabled: colors.blueDisabled,
    selected: colors.blue700,
    activeOption: colors.greyActive,
    deselected: colors.blueDeselected,
    active: colors.cactus500,
    contrast: colors.neutral200,
    inactive: colors.blue50,
  },
  text: {
    primary: colors.blue500,
    secondary: colors.blueDisabled,
    tertiary: colors.neutral500,
    selected: colors.cactus500,
    contrastText: colors.white,
    logo: colors.sunshine50,
    slider: colors.neutral500,
    tableColumn: colors.greyMedium,
    editControls: colors.pink500,
  },
  icon: {
    loyalty: colors.orange,
    heart: colors.pink500,
    loyaltyLogo: colors.cream10,
  },
};
